import React from 'react';
import { LocalPageTemplate } from '../components/LocalPageTemplate';
export function WebdesignHeemskerkPage() {
  return <LocalPageTemplate cityName="Heemskerk" region="IJmond" introText="Professionele websites voor ondernemers in Heemskerk. Wij bouwen websites die jouw bedrijf laten groeien in de IJmond-regio." localContext="Heemskerk is een groene gemeente in de IJmond met een mix van woonwijken, recreatiegebieden en bedrijvigheid. Met Slot Assumburg als historisch baken en de nabijheid van het strand biedt Heemskerk een prettige leefomgeving. De lokale economie steunt op retail, dienstverlening en de nabijheid van het industriegebied rond Tata Steel. Voor ondernemers in Heemskerk is een professionele website de sleutel om zowel lokale klanten als klanten uit de bredere IJmond-regio te bereiken." nearbyLocations={[{
    name: 'Beverwijk',
    slug: 'beverwijk'
  }, {
    name: 'Uitgeest',
    slug: 'uitgeest'
  }, {
    name: 'Castricum',
    slug: 'castricum'
  }, {
    name: 'Velsen',
    slug: 'velsen'
  }]} faqs={[{
    q: 'Wat kost een website laten maken in Heemskerk?',
    a: 'Een professionele bedrijfswebsite in Heemskerk start vanaf €1.500. De investering hangt af van je wensen, van een eenvoudige bedrijfspresentatie tot een uitgebreide site met webshop. We geven altijd vooraf een transparante offerte.'
  }, {
    q: 'Hoe word ik beter gevonden in Heemskerk en de IJmond?',
    a: 'We optimaliseren je website voor lokale zoektermen in Heemskerk en de bredere IJmond-regio (Beverwijk, Velsen, Uitgeest). Daarnaast helpen we met je Google Bedrijfsprofiel zodat je prominent verschijnt op Google Maps.'
  }, {
    q: 'Bouwen jullie ook websites voor technische bedrijven in de IJmond?',
    a: "Ja, de IJmond kent veel technische en industriële bedrijven. Wij bouwen professionele websites die vertrouwen wekken bij opdrachtgevers, met duidelijke dienstenpagina's, projectportfolio's en offerteformulieren."
  }]} data-id="element-1830" data-mp="38hwnhioqygz1" />;
}